import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3 2.75A1.75 1.75 0 0 0 1.25 4.5v16a.75.75 0 0 0 .75.75h18a.75.75 0 0 0 .735-.603l2-10A.75.75 0 0 0 22 9.75h-1.5V7.5a1.75 1.75 0 0 0-1.75-1.75h-6.399l-2.5-3zm16 7V7.5a.25.25 0 0 0-.25-.25h-7.101l-2.5-3H3a.25.25 0 0 0-.25.25v9.677l.927-3.852a.75.75 0 0 1 .73-.575H19m-16.04 10h16.425l1.7-8.5H5.086z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }